<template>
  <div style="width: 100%;">
    <Alert type="warning">
      Если вы не можете оформить заказ новой системой оформления заказов, то воспользуйтесь старой страницей оформления заказа <a href="/checkout_old/">Перейти</a>
    </Alert>
    <div v-if="private.products.length > 0 && private.order.id === null" :class="`checkout ${this.system.hasBlockSave ? 'await':''}`">

      <div class="left-side">

        <div class="checkout-block checkout-delivery">

          <div class="checkout-title">Выберите город доставки</div>
          <checkout-select :required="true" @unset="unsetError('form.locationId')" ref="form.locationId" :error="errors['form.locationId']" @refresh="processOrder" name="city_delivery" v-model="form.locationId" :items="private.cities" label="Выбор города"></checkout-select>


          <div class="checkout-title">Способ доставки</div>
          <checkout-variants @unset="unsetError('form.delivery')" @refresh="processOrder" ref="form.delivery" :error="errors['form.delivery']" v-model="form.delivery" name="delivery" :items="private.deliveries"></checkout-variants>


          <div class="checkout-title">Время доставки</div>
          <checkout-select :required="true" @unset="unsetError('form.timeId')" ref="form.timeId" :error="errors['form.timeId']" name="time_delivery" v-model="form.timeId" :items="private.time" label="Время доставки"></checkout-select>
        </div>


        <div class="checkout-block checkout-payment">
          <div class="checkout-title">Способ оплаты</div>
          <checkout-variants @unset="unsetError('form.payment')" @refresh="processOrder" ref="form.payment" :error="errors['form.payment']" v-model="form.payment" name="payment" :items="private.payments"></checkout-variants>
        </div>

        <div class="checkout-block checkout-personal">
          <div class="checkout-personal-group">
            <div class="checkout-title">Личные данные</div>

            <div ref="auth" class="nnmodal" style="display:none; width: 100%; max-width:545px; padding: 30px; border-radius: 10px;">
              <login @success="finish" :link-recovery="private.config.linkRecovery" :link-registration="private.config.linkRegistration"></login>
            </div>

            <a @click="openAuth" class="checkout-personal-signin" v-if="!private.user.id">Войти</a>
            <a class="checkout-personal-signin" @click="logout" v-else>Выйти</a>
          </div>

          <CheckoutProfile :user="private.user" v-if="private.user.id"></CheckoutProfile>

          <div class="nnform-row" v-if="!private.user.id">

            <checkout-input ref="form.personal.name" :required="true" @unset="unsetError('form.personal.name')" :error="errors['form.personal.name']" name="name" v-model="form.personal.name" label="Имя"></checkout-input>
            <checkout-input-phone ref="form.personal.phone" :required="true" @unset="unsetError('form.personal.phone')" :error="errors['form.personal.phone']" name="phone" v-model="form.personal.phone" label="Телефон"></checkout-input-phone>

          </div>


          <checkout-input v-if="!private.user.id" :required="true" name="email" ref="form.personal.email" @unset="unsetError('form.personal.email')" :error="errors['form.personal.email']" v-model="form.personal.email" label="E-mail"></checkout-input>

          <div class="checkout-title">Данные доставки</div>

          <checkout-input :required="true" @unset="unsetError('form.address.street')" ref="form.address.street" :error="errors['form.address.street']" v-model="form.address.street" label="Улица"></checkout-input>

          <div class="nnform-row --x4">
            <checkout-input ref="form.address.home" :required="true" @unset="unsetError('form.address.home')" :error="errors['form.address.home']" name="home" v-model="form.address.home" label="Дом"></checkout-input>
            <checkout-input ref="form.address.entrance" @unset="unsetError('form.address.entrance')" :error="errors['form.address.entrance']" name="entrance" v-model="form.address.entrance" label="Подъезд"></checkout-input>
            <checkout-input ref="form.address.floor" @unset="unsetError('form.address.floor')" :error="errors['form.address.floor']" name="floor" v-model="form.address.floor" label="Этаж"></checkout-input>
            <checkout-input ref="form.address.apartment" :required="true" @unset="unsetError('form.address.apartment')" :error="errors['form.address.apartment']" name="apartment" v-model="form.address.apartment" label="Квартира"></checkout-input>
          </div>

          <checkout-area ref="form.comment" @unset="unsetError('form.comment')" :error="errors['form.comment']" name="comment" v-model="form.comment" label="Комментарий к заказу"></checkout-area>

        </div>
      </div>


      <div class="right-side">

        <div class="fly-block">
          <div class="checkout-block">
            <div class="checkout-product-list">
              <div class="checkout-title">Состав заказа</div>
              <CheckoutProduct :favorite="private.favoriteData" v-for="(product, index) in private.products" :product="product"></CheckoutProduct>
            </div>

            <div class="checkout-line"></div>

            <div class="checkout-total">

              <div class="checkout-total-raw" v-if="private.order.delivery.price">
                <div class="checkout-total-raw__label">Стоимость доставки</div>
                <div class="checkout-total-raw__value">{{ private.order.delivery.formatted }}</div>
              </div>

              <div class="checkout-total-raw">
                <div class="checkout-total-raw__label">
                  <div class="checkout-total-clear" @click="clear">
                    <div class="checkout-total-clear__label">Очистить корзину</div>
                    <img class="checkout-total-clear__icon" src="/assets/images/checkout/trash.svg"/>
                  </div>
                </div>
                <div class="checkout-total-raw__value">
                  <div class="checkout-total-number">Итого: {{ private.order.total.formatted }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="checkout-block">
            <div class="nnform-element-wrapper checkout-action">
              <button type="submit" class="btn-main checkout-submit" @click="saveOrder">Оформить заказ</button>

              <div class="checkout-agree">
                Нажимая на кнопку "Оформить заказ", я даю свое <a :href="private.config.agree">согласие на обработку моих персональных данных</a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <LoadingSpiner v-if="system.hasBlockSave"></LoadingSpiner>
    </div>
    <CheckoutSuccess v-else-if="private.order.id" :order="private.order"/>
    <CheckoutEmpty v-else/>
  </div>

</template>

<script>

import CheckoutInput from "./form/CheckoutInput.vue";
import CheckoutArea from "./form/CheckoutArea.vue";
import CheckoutSelect from "./form/CheckoutSelect.vue";
import CheckoutVariants from "./custom/CheckoutVariants.vue";
import CheckoutProduct from "./CheckoutProduct.vue";
import RestRequest from "../../../tool/RestRequest";
import config from "../../../config";
import BasketService from "../../../service/BasketService";
import FavoriteService from "../../../service/FavoriteService";
import CheckoutEmpty from "./CheckoutEmpty.vue";
import CheckoutProfile from "./CheckoutProfile.vue";
import Price from "../../../tool/Price";
import ValidationService from "../../../service/ValidationService";
import CheckoutInputPhone from "./form/CheckoutInputMask.vue";
import CheckoutSuccess from "./CheckoutSuccess.vue";
import {Fancybox} from "@fancyapps/ui";
import CheckoutCheckbox from "./form/CheckoutCheckbox.vue";
import LoadingSpiner from "../loading/LoadingSpiner.vue";
import Alert from "../alert/Alert.vue";
import Login from "../auth/Login.vue";

const axios = require('axios');

export default {
  components: {
    Alert,
    LoadingSpiner,
    CheckoutCheckbox,
    CheckoutSuccess,
    CheckoutInputPhone,
    CheckoutProfile,
    CheckoutEmpty,
    CheckoutProduct,
    CheckoutVariants,
    CheckoutSelect,
    CheckoutArea,
    CheckoutInput,
    Login,
  },
  props: {
    config: {
      type: Object,
      default: {},
    },
    time: {
      type: Array,
      default: [],
    },
    cities: {
      type: Array,
      default: [],
    },
    deliveries: {
      type: Array,
      default: [],
    },
    payments: {
      type: Array,
      default: [],
    },
    user: {
      type: Object,
      default: {},
    },
    order: {
      type: Object,
      default: {},
    },
    products: {
      type: Array,
      default: [],
    },
    favoriteData: {
      type: Array,
      default: [],
    },
  },
  data: function () {
    return {
      system: {
        hasBlockSave: false,
      },
      private: {
        config: this.config,
        time: this.time,
        cities: this.cities,
        deliveries: this.deliveries,
        payments: this.payments,
        user: this.user,
        products: this.products,
        favoriteData: this.favoriteData,
        order: this.order,
      },
      errors: {},
      form: {
        locationId: null,
        timeId: null,
        delivery: null,
        payment: null,
        comment: null,
        personal: {
          name: this.user.name ?? null,
          phone: this.user.phone ?? null,
          email: this.user.email ?? null,
        },
        address: {
          street: null,
          entrance: null,
          floor: null,
          home: null,
          apartment: null,
        },
      },
      order: null,
    };
  },
  computed: {
    Price() {
      return Price
    },
    total: function () {
      let total = 0;

      this.private.products.forEach(product => {
        total += product.price.roundedPrice * product.basket_count;
      });

      return total;
    },
  },
  methods: {
    clear() {
      this.private.products.forEach(product => {
        RestRequest.delete(config.restBasket, product.id).then(result => {
          if (result.status === 200) {
            this.private.products = [];
          }
        });
      });
    },
    plus(productId, count = 1) {
      BasketService.plus(productId, count).then(result => {

        this.private.products = result.data.items;
        this.processOrder();

      });

    },
    minus(productId, count = 1) {
      BasketService.minus(productId, count).then(result => {

        this.private.products = result.data.items;
        this.processOrder();

      });
    },
    favorite(productId) {

      // Удалить
      if (this.private.favoriteData[productId] === true) {

        FavoriteService.remove(productId).then(result => {
          if (result.status === 200) {
            FavoriteService.updateCounter(true);

            this.private.favoriteData[productId] = false;
          }
        });

      } else {

        FavoriteService.add(productId).then(result => {
          if (result.status === 200) {
            FavoriteService.updateCounter();

            this.private.favoriteData[productId] = true;
          }
        });

      }
    },
    remove(productId) {
      BasketService.remove(productId).then(result => {
        if (result.data.status === 200) {
          this.private.products = this.private.products.filter(product => product.id !== productId);

          this.processOrder();
        }
      });

    },
    processOrder() {

      if (this.system.hasBlockSave) {
        return false;
      }

      this.system.hasBlockSave = true;

      axios.post('', {
        ...this.form,
        action: 'processOrder',
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            this.private.order = response.data.data.order;
            this.private.deliveries = response.data.data.deliveries;
            this.private.payments = response.data.data.payments;
            this.system.hasBlockSave = false;

            if (!this.private.deliveries.find((deliveryItem) => this.form.delivery === deliveryItem.id)) {
              this.form.delivery = null;
            }
            if (!this.private.payments.find((paymentItem) => paymentItem.id === this.form.payment)) {
              this.form.payment = null;
            }
          })
          .catch(function (error) {
          });

    },
    validate() {

      if (!this.form.locationId) {
        this.setError('form.locationId', 'Выберите город для доставки');
      }

      if (!this.form.delivery) {
        this.setError('form.delivery', 'Выберите вариант доставки');
      }

      if (!this.form.timeId) {
        this.setError('form.timeId', 'Выберите время доставки');
      }

      if (!this.form.payment) {
        this.setError('form.payment', 'Выберите вариант оплаты');
      }

      if (!this.form.personal.name) {
        this.setError('form.personal.name', 'Укажите ваше имя');
      }

      if (!this.form.personal.phone) {
        this.setError('form.personal.phone', 'Заполните номер телефона');
      }

      if (!this.form.personal.email) {
        this.setError('form.personal.email', 'Заполните E-mail адрес');
      }

      if (!this.form.address.street) {
        this.setError('form.address.street', 'Укажите улицу');
      }

      if (!this.form.address.home) {
        this.setError('form.address.home', 'Укажите номер дома');
      }

      if (!this.form.address.apartment) {
        this.setError('form.address.apartment', 'Укажите номер квартиры');
      }


      Object.keys(this.errors).every(key => {
        if (this.errors[key] !== false) {
          this.$refs[key].$el.scrollIntoView({behavior: "smooth"});
          return false;
        }

        return true;
      });
    },
    setError(key, message) {
      this.errors[key] = message;
    },
    unsetError(key) {
      this.errors[key] = false;
    },
    hasErrors() {
      return Object.keys(this.errors).map(key => {
        return this.errors[key] !== false;
      }).find(value => value === true);
    },
    saveOrder() {

      if (this.system.hasBlockSave) {
        return false;
      }

      this.validate();

      if (this.hasErrors()) {
        return false;
      }

      this.system.hasBlockSave = true;

      axios.post('', {
        ...this.form,
        action: 'saveOrder',
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            if (response.data.data.order) {
              this.private.order = response.data.data.order;
              this.private.products = [];
              this.system.hasBlockSave = false;
            }
          })
          .catch(function (error) {
            // console.error(error);
          });


    },
    openAuth() {
      Fancybox.show([{src: this.$refs.auth, type: "inline"}]);
    },
    finish(user) {
      this.private.user = user;
      Fancybox.destroy();
    },
    logout() {
      axios.post('', {
        action: 'logout',
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
          .then(response => {
            this.private.user = [];
            this.form.personal.email = null;
            this.form.personal.phone = null;
            this.form.personal.name = null;
          })
          .catch(function (error) {
            // console.error(error);
          });
    },
  },
  name: "checkout",
  el: "#checkout",
}
</script>

<style scoped>

</style>
